import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Card, CardContent } from '@ovComponents/2-component/card/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  TableTotalCell,
} from '@ovComponents/2-component/table/table';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type ArchiveObjectsTableProps = {
  readonly title: string;
  readonly columns: string[];
  readonly rows: string[][];
};

export const ArchiveObjectsTable: FC<ArchiveObjectsTableProps> = ({
  title,
  columns,
  rows,
}) => {
  const { t } = useTranslation(['workflowCompletions']);

  if (rows.length === 0) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Card>
        <CardContent>
          <Typography variant='bodyLarge' weight='bold' sx={{ mb: 1 }}>
            {title}
          </Typography>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead sx={{ display: 'table-header-group' }}>
              <TableRow>
                {columns.map((col, idx) => (
                  <TableHeadCell
                    key={col}
                    isFirst={idx === 0}
                    right={idx !== 0 && idx === columns.length - 1}
                  >
                    {col}
                  </TableHeadCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody sx={{ display: 'table-row-group' }}>
              {rows.map((row, rowIdx) => (
                <TableRow key={row[0] ?? rowIdx}>
                  {row.map((cell, cellIdx) => (
                    <TableCell
                      key={columns[cellIdx] ?? cellIdx}
                      isFirst={cellIdx === 0}
                      right={cellIdx !== 0 && cellIdx === row.length - 1}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              <TableRow>
                <TableTotalCell bold>
                  {t('workflowCompletions:archiveObjects.total', {
                    count: rows.length,
                  })}
                </TableTotalCell>
                {columns.slice(1).map((col) => (
                  <TableTotalCell key={`total-${col}`} />
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
};
